import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LoadingSpinnerComponent } from "./share/components/loading-spinner/loading-spinner.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { Meta } from "@angular/platform-browser";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	standalone: true,
	imports: [RouterOutlet, LoadingSpinnerComponent, TranslateModule]
})
export class AppComponent {
	title = "group-main-site";

	constructor(
		private translate: TranslateService,
		private meta: Meta
	) {
		this.translate.setDefaultLang("en");
		this.translate.use("en");

		if (!environment.production) {
			this.meta.addTag({ name: "robots", content: "noindex, nofollow" });
		}
	}
}
